
sap["ls"]["preload"]["UCF_PlaceHolder"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../../core/FocusInfo.js"/>

/**
 * Helper Class for all controls that need to survive roundtrips
 *
 * Following rules have to be taken care of for the rendering:
 * - Root container/content ids either "id-r"/"id" OR "id"/"id-o"
 * - A XMP as first child which contains HTML of the real control
 *
 * 
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {HTMLElement} oDomRef
 */
function UCF_PlaceHolder(oLS, oDomRef) {if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["UCF_PlaceHolder"]++; }; 

	if (arguments["length"] === 0) return;

	UCF_Control["apply"](this, [oLS, oDomRef]);

	this["oPopupWindow"] = null;

	// Flag to control extra IE6-only specific handling. Destroying of DOM
	// has to be skipped otherwise iframe onunload is not fired.  see int CSN: 601001 2010
	this["bSkipDomDestroy"] = false;

	// lifecycle flags
	this["bKeepAlive"] = (this["sLifeCycle"] !== "BROWSER");
	this["bVisible"] = true;

	if (this["bKeepAlive"]) {

		if (this["oRootRef"]) {
			this["attachBrowserEvent"]("resize", this["oRootRef"]);
		}

		this["oContentRef"] = UCF_DomUtil["$"](this["sId"] + "-ph");
		this["oXMPRef"] = UCF_DomUtil["$"](this["sId"] + "-obj");
		this["sContent"] = this["oRootRef"]["firstChild"]["innerHTML"];

		var sScrollAreaId = this["oXMPRef"]["getAttribute"]("cid");
		this["oScrollAreaRef"] = sScrollAreaId ? UCF_DomUtil["$"](sScrollAreaId) : null;

		this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "update");
		var oPM = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
		if (oPM) {
			oPM["attachEvent"](oPM["E_EVENTS"]["PopupOpen"], this, 'update');
		}

		// For accessibility and TrackSwitches
		this["attachBrowserEvent"]("focusin", this["oContentRef"]);

		// attach extra handler for IE-6-only handling iframe onuload  - int. CSN 601001 2010
		if (UCF_UserAgent["bIsIE"](6, true)) {
			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["BeforeDestroy"], this, "onLSBeforeDestroy");
		}
	}

};window["UCF_PlaceHolder"] = UCF_PlaceHolder; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PlaceHolder"); UCF_PlaceHolder["_"] = {UCF_PlaceHolder: 0}; }; ;
UCF_PlaceHolder["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PlaceHolder.prototype["sClassName"] = "UCF_PlaceHolder";

/**
 * Destructor
 */
UCF_PlaceHolder["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["destroy"]++; }; 

	if (UCF_UserAgent["bIsIE"](6, true)) {
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeDestroy"], this);
	}

	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
	var oPM = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
	if (oPM) {
		oPM["detachEvent"](oPM["E_EVENTS"]["PopupOpen"], this, 'update');
	}

	if (this["oRootRef"]) {
		this["detachBrowserEvent"]("resize", this["oRootRef"]);
	}
	// DIV-popup support -  see update()
	if (this["oPopupWindow"]) {
		this["oPopupWindow"]["detachEvent"](this["oPopupWindow"]["E_EVENTS"]["Move"], this);
		this["oPopupWindow"]["detachEvent"](this["oPopupWindow"]["E_EVENTS"]["Resize"], this);
		this["oPopupWindow"]["detachEvent"](this["oPopupWindow"]["E_EVENTS"]["MoveAndResize"], this);
	}

	// detach extra handler for IE-6-only handling iframe onuload  - int. CSN 601001 2010
	if (UCF_UserAgent["bIsIE"](6, true)) {
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeDestroy"], this, "onLSBeforeDestroy");
	}

	if (this["oContentRef"]) {
		this["detachBrowserEvent"]("focusin", this["oContentRef"]);
		var oParentRef = this["oContentRef"]["parentNode"];
		if (oParentRef) {

			if (!this["bSkipDomDestroy"]) {
				oParentRef["removeChild"](this["oContentRef"]);
			}
			this["oContentRef"] = null;
		}
	}

	this["oXMPRef"] = null;
	this["sContent"] = null;
	this["oScrollAreaRef"] = null;
	this["oPopupWindow"] = null;
	this["oRootRectBackup"] = null;
	this["bKeepAlive"] = false;

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["destroy"] = 0; };

/**
 *  When LS is being destoyed and extra handling for IE-6 gets activated
 * @param {UCF_Event} oEvent
 */
UCF_PlaceHolder["prototype"]["onLSBeforeDestroy"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onLSBeforeDestroy"]++; }; 
	this["bSkipDomDestroy"] = true;
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onLSBeforeDestroy"] = 0; };

/**
 * When initializes update the position of the content div
 */
UCF_PlaceHolder["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["initialize"]++; }; 

	if (this["oContentRef"]) {
		this["update"]();

		// Workaround FireFox update issue. See external OSS 0120050409 0000016081 2015
		// DOM is not painted and calucalted but the Placeholder position initialization has been triggred before the right
		// dimensions have been established. This leads sometimes to a wrong caluclated position.
		// Oms delayed did not succeed. "MozAfterPaint" event has to be activated by browser preferences which is also no option.
		// Desperate trial:
		if (UCF_UserAgent["bIsFirefox"]()) {
			UCF_JsUtil["delayedCall"](500, this, "update"); //Ignition 1
			UCF_JsUtil["delayedCall"](1000, this, "update"); //Ignition 2
			UCF_JsUtil["delayedCall"](2000, this, "update"); //Ignition 3
			UCF_JsUtil["delayedCall"](4000, this, "update"); //Ignition 4
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["initialize"] = 0; };

/**
 * Determine the root reference of the Placeholder control
 *
 * @return {HTMLElement} the root reference of the Placeholder control
 */
UCF_PlaceHolder["prototype"]["oGetRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetRootRef"]++; }; 
	var oObjectRef = UCF_DomUtil["$"](this["sId"] + "-o");
	return oObjectRef ? UCF_DomUtil["$"](this["sId"]) : UCF_DomUtil["$"](this["sId"] + "-r");
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetRootRef"] = 0; };

/**
 * Determine the object reference of the Placeholder control
 * @return {HTMLElement}
 */
UCF_PlaceHolder["prototype"]["oGetObjectRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetObjectRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-o") || UCF_DomUtil["$"](this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetObjectRef"] = 0; };

/**
 * Reconnects the control to its DOM representation, used for keepalive controls
 */
UCF_PlaceHolder["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["reconnectToDom"]++; }; 

	if (this["oContentRef"]) {

		if (this["oRootRef"]) {
			this["detachBrowserEvent"]("resize", this["oRootRef"]);
		}

		var oDomRef = UCF_DomUtil["$"](this["sId"]),
			oRootRef = this["oGetRootRef"]();

		if (oRootRef) {
			this["setDefaultValues"]();
			this["connectToDom"](oDomRef);
			this["attachBrowserEvent"]("resize", this["oRootRef"]);
		} else {
			this["hidePlaceholder"]();
			this["oRootRef"] = null;
		}

	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["reconnectToDom"] = 0; };

/**
 * @see UCF_Control
 * @param {UCF_FocusInfo} oFocusInfo
 */
UCF_PlaceHolder["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "PlaceHolder.js(209): collectFocusInfo"); };

	oFocusInfo["setApplyControl"](this);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @param { UCF_FocusInfo } oFocusInfo
 */
UCF_PlaceHolder["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "PlaceHolder.js(219): applyFocusInfo"); };
	// if the Placeholder control has already the focus in keepAlive mode then avoid setting an additional focus because the browser
	// scrolls the control completely into view port. The page "jitters". Placeholder controls are usually quite big controls. Therefore
	// the effect is dominant.

	if (!this["bKeepAlive"] || UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
		this["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["applyFocusInfo"] = 0; };

/**
 * Returns whether the control should be kept alive.
 * In case of keep alive, check whether content has changed
 *
 * @return {boolean}
 */
UCF_PlaceHolder["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bDoKeepAlive"]++; }; 

	// In case of scrollcontainers the content div may get lost
	var oContentRef = UCF_DomUtil["$"](this["sId"] + "-ph");

	if (this["bKeepAlive"] && oContentRef) {
		var oNewRootRef = this["oGetRootRef"]();
		if (oNewRootRef) {
			// if there is a new control with same id compare the content
			var sNewContent = oNewRootRef["firstChild"]["innerHTML"];
			return (this["sContent"] === sNewContent);
		} else {
			// if no new control is sent, only keep alive if set to MANUAL
			return (this["sLifeCycle"] === "MANUAL");
		}
	}
	return false;

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bDoKeepAlive"] = 0; };

/**
 * When resized update the position
 */
UCF_PlaceHolder["prototype"]["onresize"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onresize"]++; }; 

	if (this["oContentRef"]) {
		this["update"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onresize"] = 0; };

/**
 * Checks if the control has a valid DOM reference.
 * For PlaceHolder the relevant element to check is the root
 * reference, as the control itself is never removed
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_PlaceHolder["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bIsValid"]++; }; 

	if (this["oContentRef"]) {
		if (!UCF_DomUtil["bIsInActiveDom"](this["oDomRef"])) return false;
		var oRootRef = this["oGetRootRef"]();
		return (oRootRef != null && oRootRef === this["oRootRef"]);
	} else {
		return UCF_Control.prototype["bIsValid"]["apply"](this, arguments);
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bIsValid"] = 0; };

/**
 * Calculate position of the root element and place the content on top of it
 * @param {UCF_Event} [oEvent] The internal event, if called as event handler
 */
UCF_PlaceHolder["prototype"]["update"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["update"]++; }; 

	if (!this["oRootRef"] || UCF_DomUtil["sGetCurrentStyle"](this["oRootRef"], 'visibility') === 'hidden') {
		this["hidePlaceholder"]();
		this["bVisible"] = false;
		return;
	} else {
		this["bVisible"] = true;
	}

	var oRootRect = UCF_DomUtil["oGetObjectRect"](this["oRootRef"], this["oScrollAreaRef"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "top:" + oRootRect["top"] + "; left:" + oRootRect["left"] + "; height:" + oRootRect["height"] + "; width:" + oRootRect["width"], "PlaceHolder.js(300): update"); };

	// if running in a scrollcontainer, where a padding is defined, the padding has to be substracted
	// from the top and left position, as relative positioning is used inside the scrollcontainer
	if (this["oScrollAreaRef"] && this["oScrollAreaRef"]["currentStyle"]) {
		var iPaddingTop = parseInt(this["oScrollAreaRef"]["currentStyle"]["paddingTop"]) || 0,
			iPaddingLeft = parseInt(this["oScrollAreaRef"]["currentStyle"]["paddingLeft"]) || 0;
		oRootRect["top"] -= iPaddingTop;
		oRootRect["left"] -= iPaddingLeft;
	}

	if (!UCF_UserAgent["bIsFirefox"]() && (oRootRect["height"] === 0 || (oRootRect["top"] + oRootRect["height"]) < 0)) {
		this["hidePlaceholder"]();
		return;
	}

	// Support modal DIV-popups in WDA: Workaround for z-index. We support only a single Popup with PH inside.
	// The following code is not possible during createContent() because it is called in ControlFactory before the constructor(!)
	if (this["oPopupWindow"] === null && UCF_DomUtil["bContains"](this["oLS"]["oGetStaticAreaRef"](), this["oContentRef"])) {
		var oPW = this["oGetParentPopupWindow"](this["oXMPRef"]);
		// Note: bIsModalDivPopup() returns null if Popup is not yet initialized (e.g. during purge by an update the PH maybe purged before the Popup)
		// Note: z-index is not calculated although PW is initialized and PopupManager.register() was called because of the WDA-ID-order workaaround(!)
		//       => do NOT store this.oPopupWindow yet, update will be called again on PopupManager.OpenPopup event
		if (oPW && oPW["bIsModalDivPopup"]() === true && !isNaN(oPW["iGetZIndex"]())) {
			this["oPopupWindow"] = oPW;
			oPW["attachEvent"](oPW["E_EVENTS"]["Move"], this, "update");
			oPW["attachEvent"](oPW["E_EVENTS"]["Resize"], this, "update");
			oPW["attachEvent"](oPW["E_EVENTS"]["MoveAndResize"], this, "update"); // fired by maximize/restore
			this["oRootRectBackup"] = oRootRect;
		}
	}

	// Support for modal DIV-popups:
	// Adapt size of root container when PopupWindow is resized
	if (this["oPopupWindow"]) {
		// For IFrame, rely on the internal "resize" event notification
		// instead of events and calculations from the Popup...
		// see: UCF_IFrame.onresize() which calls _super() !
		if (this["sClassName"] !== 'UCF_Iframe') {
			var oParam = oEvent ? oEvent["mGetParameters"]() : null;
			// Internal Resize-event from Popup has this parameter
			var oCntSize = oParam ? oParam["ContentInnerSize"] : null;
			// PopupOpen event from PopupManager: Ask popup directly about inner content size
			if (!oCntSize) oCntSize = this["oPopupWindow"]["oPWDimensions"] ? this["oPopupWindow"]["oPWDimensions"]["oGetContentInnerSize"]() : this["oPopupWindow"]["oGetContentInnerSize"]();
			if (oCntSize) {
				if (this["oRootRef"]["style"]["width"]["indexOf"]('%') === -1) {
					if (oCntSize["width"] < this["oRootRectBackup"]["width"]) {
						oRootRect["width"] = oCntSize["width"];
					} else {
						oRootRect["width"] = this["oRootRectBackup"]["width"];
					}
					this["oRootRef"]["style"]["width"] = oRootRect["width"] + "px";
				}
				if (this["oRootRef"]["style"]["height"]["indexOf"]('%') === -1) {
					if (oCntSize["height"] < this["oRootRectBackup"]["height"]) {
					oRootRect["height"] = oCntSize["height"];
					} else {
						oRootRect["height"] = this["oRootRectBackup"]["height"];
					}
					this["oRootRef"]["style"]["height"] = oRootRect["height"] + "px";
				}
			}
		}
		this["oContentRef"]["style"]["zIndex"] = this["oPopupWindow"]["iGetZIndex"]() + 10;
	}

	for (var i in oRootRect) {
		this["oContentRef"]["style"][i] = oRootRect[i] + "px";
		// Works without this for IFrame (?)
		// if (this.oPopupWindow && this.sClassName === 'UCF_Iframe') {
		// 	this.oRootRef.style[i] = oRootRect[i] + "px";
		// }
	}

	// IE does not size iframe smaller than 150px, if height is set to 100%
	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && this["oDomRef"]["tagName"] === "IFRAME") {
		this["oDomRef"]["style"]["height"] = oRootRect["height"] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["update"] = 0; };


/**
 * Hide the content control by positioning it at top -10000px
 */
UCF_PlaceHolder["prototype"]["hidePlaceholder"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hidePlaceholder"]++; }; 
	if (this["oContentRef"]) {
		this["oContentRef"]["style"]["top"] = "-10000px";
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hidePlaceholder"] = 0; };

/**
 * Hides the content control
 */
UCF_PlaceHolder["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hide"]++; }; 
	if (this["oContentRef"]) {
		this["oContentRef"]["style"]["top"] = "-10000px";
	}
	UCF_Control.prototype["hide"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hide"] = 0; };

/**
 * Shows the  control
 */
UCF_PlaceHolder["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["show"]++; }; 
	UCF_Control.prototype["show"]["apply"](this, arguments);
	if (this["oContentRef"]) {
		this["update"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["show"] = 0; };

/**
 * Set flag to keep the control alive, even if it is not visible on the screen
 *
 * @param {boolean} bKeepAlive
 * @public
 */
UCF_PlaceHolder["prototype"]["setKeepAlive"] = function(bKeepAlive) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setKeepAlive"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["sLifeCycle"] === "MANUAL", "this.sLifeCycle === \"MANUAL\"", "PlaceHolder.js(418): setKeepAlive"); };

	if (this["sLifeCycle"] === "MANUAL") {
		this["bKeepAlive"] = bKeepAlive;
		if (!bKeepAlive) {
			UCF_JsUtil["delayedCall"](0, this["oLS"]["oControlFactory"], "purgeControl", [this]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setKeepAlive"] = 0; };

/**
 * Create the placeholder content.
 * This method is called by the ControlFactory.
 *
 * @param {string} sId
 * @param {element} oXMPRef
 * @param {element} oStaticAreaRef
 *
 */
UCF_PlaceHolder["createContent"] = function(sId, oXMPRef, oStaticAreaRef) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["createContent"]++; }; 
	var oScrollRef = null,
		oContentRef = document["createElement"]("div");

	oContentRef["setAttribute"]("id", sId + "-ph");
	oContentRef["style"]["overflow"] = "hidden";

	{
		// Loop up the DOM and look for a LS scroll container (-scrl)
		var oDomRef = oXMPRef,
			sScrollId;

		while (oDomRef && oDomRef !== document) {
			sScrollId = oDomRef["getAttribute"]("id");
			// important to check overflow because -scrl is used
			// by several controls for overflow=visible (default) -> see also int. 525773 2010
			if (sScrollId && sScrollId["indexOf"]("-scrl") > 0 && UCF_DomUtil["sGetCurrentStyle"](oDomRef, "overflow") !== "visible") {
				oScrollRef = oDomRef;
				break;
			}
			oDomRef = oDomRef["parentNode"];
		}
	}

	if (oScrollRef) {
		sScrollId = oScrollRef["getAttribute"]("id");
		if (!sScrollId) {
			sScrollId = sId + "-" + UCF_JsUtil["iGetTimeStamp"]();
			oScrollRef["setAttribute"]("id", sScrollId);
		}
		oXMPRef["setAttribute"]("cid", sScrollId);
	}

	UCF_DomUtil["oAddLayeredElement"](oContentRef, oStaticAreaRef, oScrollRef, true);

	// Temporary HACK BEGIN :: APPLET & Placeholder PZ:----
	var sMarkup = oXMPRef["innerHTML"];
	var iCt = sMarkup["indexOf"]('ct=\"AP\"');
	var iLsevents = sMarkup["indexOf"]("lsevents=");

	if (iCt >= 0 && iLsevents < 0) {
		// add missing attributes ti & lsevents
		sMarkup = sMarkup["substring"](0, iCt + 7)
			+ " ti=\"0\" lsevents={} "
			+ sMarkup["substring"](iCt + 7);
	}
	// sMarkup is extracted from contents coming from the server response
	UCF_DomUtil["setInnerHtml"](oContentRef, sMarkup);
	// UCF_DomUtil.setInnerHtml(oContentRef, oXMPRef.innerHTML);
	// Temporary HACK END :: APPLET & Placeholder PZ:----
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["createContent"] = 0; };

/**
 * Sets the visibility for a control
 * @param {string} sVisibility The visibility of the control "BLANK", "NONE","VISIBLE"
 * @public
 */
UCF_PlaceHolder["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setVisibility"]++; }; 
	UCF_Control.prototype["setVisibility"]["apply"](this, arguments);
	if (this["oContentRef"]) {
		UCF_DomUtil["setVisibility"](this["oContentRef"], sVisibility);
		this["update"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setVisibility"] = 0; };


UCF_PlaceHolder.prototype["aPublicMethods"] = ["setKeepAlive","setVisibility"].concat(UCF_PlaceHolder.prototype.aPublicMethods || []);
};